import React from 'react';
import { Chip, Box } from '@mui/material';
import { 
  ReportProblem, 
  Warning, 
  Info, 
  CheckCircle 
} from '@mui/icons-material';

interface RiskScoreBadgeProps {
  score: number;
  level: 'CRITICAL' | 'HIGH' | 'MEDIUM' | 'LOW';
  size?: 'small' | 'medium';
  variant?: 'filled' | 'outlined';
}

const RiskScoreBadge: React.FC<RiskScoreBadgeProps> = ({ 
  score, 
  level, 
  size = 'small',
  variant = 'filled'
}) => {
  const getColor = (): 'error' | 'warning' | 'info' | 'success' | 'default' => {
    switch(level) {
      case 'CRITICAL': return 'error';
      case 'HIGH': return 'warning';
      case 'MEDIUM': return 'info';
      case 'LOW': return 'success';
      default: return 'default';
    }
  };

  const getIcon = () => {
    switch(level) {
      case 'CRITICAL': return <ReportProblem />;
      case 'HIGH': return <Warning />;
      case 'MEDIUM': return <Info />;
      case 'LOW': return <CheckCircle />;
      default: return <Info />;
    }
  };

  const getLabel = () => {
    if (size === 'small') {
      return `${level}`;
    }
    return `Risk: ${score.toFixed(1)} (${level})`;
  };

  return (
    <Chip
      icon={getIcon()}
      label={getLabel()}
      color={getColor()}
      size={size}
      variant={variant}
      sx={{ 
        fontWeight: 'bold',
        '& .MuiChip-icon': {
          fontSize: size === 'small' ? 14 : 18
        }
      }}
    />
  );
};

export default RiskScoreBadge;